import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { cartOperations } from "../../state/ducs/cart";
import { globalOperations } from "../../state/ducs/globalState";

const TopDealsCard = (props) => {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [isHovered, setIsHovered] = useState(false);
  const [discount] = useState(Math.floor(Math.random() * 40) + 10); // Random discount 10-50%
  const originalPrice = Math.floor(props.productObj.price * (100 + discount) / 100);

  const detailsClickHandler = () => {
    props.setSelectedProductVendorName(props.productObj.vendor_name);
  }

  const addToCartHandler = () => {
    const other_vendor_products = props.cartItems.filter(item => item.vendor_name !== props.productObj.vendor_name);

    if (other_vendor_products.length) {
      alert("You can order single vendor product only at a time");
      return;
    }
    detailsClickHandler();
    props.addToCart(props.productObj);
    props.showAddToCartModal();
  };

  const numberWithCommas = (x) => {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const truncateTitle = (title, maxLength = 40) => {
    return title.length > maxLength ? title.substring(0, maxLength) + "..." : title;
  };

  return (
    <div 
      className="deal-card"
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="deal-image-container">
        <Link onClick={detailsClickHandler} to={"/productDetails/" + props.productObj.id}>
          {!imageLoaded && (
            <div className="image-placeholder">
              <div className="placeholder-spinner"></div>
            </div>
          )}
           <img
             src={`${process.env.REACT_APP_PRODUCT_IMAGE_URL}/${props.productObj.photo}`}
             className={`deal-image ${imageLoaded ? 'loaded' : ''}`}
             alt={props.productObj.name}
             onLoad={() => setImageLoaded(true)}
             onError={(e) => {
               e.target.src = `${process.env.REACT_APP_API_URL}/placeholder/300/300`;
               setImageLoaded(true);
             }}
          />
        </Link>
        
        <div className={`deal-overlay ${isHovered ? 'visible' : ''}`}>
          <div className="deal-actions">
            <button className="action-btn" title="Add to Wishlist">
              <i className="fa fa-heart"></i>
            </button>
            <button className="action-btn" title="Quick View">
              <i className="fa fa-search"></i>
            </button>
            <button className="action-btn" title="Compare">
              <i className="fa fa-exchange"></i>
            </button>
          </div>
        </div>

        <div className="deal-badges">
          <div className="discount-badge">-{discount}%</div>
          <div className="deal-badge">DEAL</div>
        </div>

        <div className="deal-flash">
          <div className="flash-animation"></div>
        </div>
      </div>

      <div className="deal-info">
        <div className="deal-rating">
          <div className="stars">
            {[1, 2, 3, 4, 5].map((star) => (
              <i key={star} className="fa fa-star"></i>
            ))}
          </div>
          <span className="rating-text">(4.{Math.floor(Math.random() * 9)})</span>
        </div>

        <h3 className="deal-title">
          <Link 
            onClick={detailsClickHandler} 
            to={"/productDetails/" + props.productObj.id}
            title={props.productObj.name}
          >
            {truncateTitle(props.productObj.name)}
          </Link>
        </h3>

        <div className="deal-prices">
          <div className="current-price">
            ৳{numberWithCommas(props.productObj.price)}
          </div>
          <div className="original-price">
            ৳{numberWithCommas(originalPrice)}
          </div>
          <div className="savings">
            Save ৳{numberWithCommas(originalPrice - props.productObj.price)}
          </div>
        </div>

        <div className="deal-progress">
          <div className="progress-bar">
            <div className="progress-fill" style={{width: `${Math.floor(Math.random() * 60) + 20}%`}}></div>
          </div>
          <div className="stock-text">Hurry! Only few left</div>
        </div>

        <button 
          onClick={addToCartHandler} 
          className="grab-deal-btn"
        >
          <i className="fa fa-bolt"></i>
          Grab This Deal
        </button>
      </div>
    </div>
  );
};

const mapStateToProps = (state) => {
  return { cartItems: state.cart };
};

const mapDispatchToProps = {
  addToCart: cartOperations.addToCart,
  showAddToCartModal: globalOperations.showAddToCartModal,
  setSelectedProductVendorName: globalOperations.setSelectedProductVendorName,
};

export default connect(mapStateToProps, mapDispatchToProps)(TopDealsCard);